import React from 'react'

const infoIcon = (props: any) => {
    const {className={}, fill}= props;
  return (
    <svg
      width="12"
      className={className}
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1555_2219)">
        <path
          d="M6.80169 8.45472C6.67902 8.46615 6.55586 8.43847 6.44987 8.37562C6.37243 8.29612 6.33531 8.18575 6.34897 8.07562C6.35183 7.98393 6.36278 7.89266 6.38169 7.8029C6.4 7.69991 6.42364 7.59796 6.45259 7.49744L6.77441 6.39015C6.8076 6.28087 6.82954 6.16846 6.83987 6.05469C6.83987 5.93197 6.85623 5.84741 6.85623 5.79833C6.86307 5.57959 6.76968 5.36969 6.60259 5.22833C6.39707 5.07055 6.14113 4.993 5.88259 5.01015C5.69732 5.01294 5.51347 5.04327 5.33713 5.10015C5.1444 5.16015 4.94167 5.23197 4.72895 5.31562L4.63623 5.67561C4.69895 5.65379 4.77533 5.62926 4.86259 5.60197C4.94584 5.57732 5.03214 5.56445 5.11895 5.56379C5.24073 5.5506 5.36331 5.58051 5.46531 5.64833C5.53459 5.731 5.5671 5.83839 5.55531 5.94562C5.555 6.03733 5.54495 6.12876 5.52531 6.21833C5.50621 6.3138 5.48167 6.41469 5.45167 6.52105L5.12713 7.63377C5.10097 7.7372 5.08004 7.84187 5.06441 7.94741C5.05166 8.03776 5.04529 8.12889 5.04531 8.22013C5.04397 8.44037 5.14468 8.64883 5.31803 8.78467C5.52672 8.94491 5.78631 9.02434 6.04893 9.00831C6.23385 9.01211 6.41814 8.98539 6.59439 8.92921C6.74893 8.87647 6.9553 8.80103 7.21349 8.70285L7.30077 8.35921C7.23083 8.38822 7.15881 8.41192 7.08531 8.43011C6.99236 8.45134 6.89692 8.45959 6.80169 8.45472Z"
          fill={fill}
        />
        <path
          d="M7.14277 3.20479C6.99434 3.06848 6.79878 2.99514 6.59731 3.00025C6.39596 2.9957 6.20059 3.06897 6.05185 3.20479C5.77923 3.43987 5.74878 3.85145 5.98388 4.1241C6.00484 4.14841 6.02755 4.17112 6.05185 4.19207C6.36244 4.46988 6.83218 4.46988 7.14275 4.19207C7.41537 3.95467 7.44394 3.54123 7.20655 3.26861C7.18681 3.2459 7.16548 3.22457 7.14277 3.20479Z"
          fill={fill}
        />
        <path
          d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 11.4545C2.98753 11.4545 0.545461 9.01247 0.545461 6C0.545461 2.98753 2.98753 0.545461 6 0.545461C9.01247 0.545461 11.4545 2.98753 11.4545 6C11.4545 9.01247 9.01247 11.4545 6 11.4545Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1555_2219">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default infoIcon
